module.exports = "/images/landing-page.png?89d4efe041480570c754b9ad9345ad9d";